import { type PayloadAction, createSlice } from '@reduxjs/toolkit'

import type { TPlan } from '@web/entities/plan'
import { useDispatchedActions } from '@web/shared/hooks/use-dispatched-actions.hook'

export interface IPlansState {
  plans: TPlan[]
}

const initialState: IPlansState = {
  plans: []
}

export const plansSlice = createSlice({
  name: 'plans',
  initialState,
  reducers: {
    setPlans(state, action: PayloadAction<TPlan[]>) {
      state.plans = action.payload
    }
  }
})

export const plansReducer = plansSlice.reducer
export const usePlansActions = () => useDispatchedActions(plansSlice.actions)